import { FC, PropsWithChildren, ReactNode, useState } from 'react';
import { partTestId } from '@connect-x-app/shared-utils';
import classNames from 'classnames';

import { Icon } from '../icon';

import './CollapsibleView.scss';

type CollapsibleViewProps = PropsWithChildren & {
  className?: string;
  expanded?: boolean;
  headerContent: ReactNode;
  testId?: string;
};

export const CollapsibleView: FC<CollapsibleViewProps> = ({ children, className, expanded = false, headerContent, testId }) => {
  const [isExpanded, setIsExpanded] = useState(expanded);

  const onToggle = () => {
    setIsExpanded(expanded => !expanded);
  };

  return (
    <div className={classNames('collapsible-view', className)} data-test={testId}>
      <div className="collapsible-view-header" data-test={partTestId(testId, 'header')} onClick={onToggle} role="presentation">
        {headerContent}
        <div className="collapsible-view-header-icons">
          <Icon
            name={isExpanded ? 'chevronUp' : 'chevronDown'}
            testId={partTestId(testId, isExpanded ? 'chevronUp' : 'chevronDown')}
          />
        </div>
      </div>
      <div className={classNames('collapsible-view-content', isExpanded && 'open')} role="presentation">
        {children}
      </div>
    </div>
  );
};
